import { findKey } from 'lodash';

class Environment {
  static get envs() {
    return {
      local: /localhost:9000/,
      localAlula: /localhost:8080/,
      localDev: /localhost:3000/,
      r3Dev: /dev.alulavideo.net/,
      dev: /dev\./,
      prod: /alarmdealer.com/
    };
  }

  static get env() {
    const url = window.location.href;
    return findKey(this.envs, env => env.test(url)) || 'dev';
  }

  static get alulaApi() {
    const urls = {
      local: 'https://api-dev.alula.net/rest',
      localAlula: 'https://api-dev.alula.net/rest',
      localDev: 'https://api-dev.alula.net/rest',
      r3Dev: 'https://api-dev.alula.net/rest',
      dev: 'https://api-dev.alula.net/rest',
      prod: 'https://api.ipdatatel.com/rest'
    };
    return urls[this.env];
  }

  static get authApi() {
    const urls = {
      local: 'http://<host>/token?token=<token>',
      localAlula: 'http://<host>/token?token=<token>',
      localDev: 'http://<host>/token?token=<token>',
      r3Dev: 'https://<host>/token?token=<token>',
      dev: 'https://<host>/index.php?mod=api&action=urltoken&token=<token>',
      prod: 'https://<host>/index.php?mod=api&action=urltoken&token=<token>'
    };
    return urls[this.env];
  }

  static get videoApi() {
    const urls = {
      local: 'http://localhost:3002',
      localAlula: 'https://api-dev.alula.net/video',
      localDev: 'https://gateway.dev.alulavideo.net',
      r3Dev: 'https://gateway.dev.alulavideo.net',
      dev: 'https://api-dev.alula.net/video',
      prod: 'https://api.ipdatatel.com/video'
    };
    return urls[this.env];
  }

  static get defaultLoginUrl() {
    const urls = {
      local: 'http://localhost:3001',
      localAlula: 'http://localhost:3001',
      localDev: 'http://localhost:3001',
      r3Dev: 'https://video-auth.dev.alulavideo.net',
      dev: 'https://ad-dev.alula.net/index.php?mod=auth&action=login',
      prod: 'https://alarmdealer.com/index.php?mod=auth&action=login'
    };
    return urls[this.env];
  }
}

export default Environment;



// WEBPACK FOOTER //
// ./src/api/Environment.js